import { Contact, ContactRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createNominationContact: (
  fetchContext: FetchContext,
  nominationId: number,
  contact: Contact,
  accessToken?: string,
) => Promise<ContactRef> = (fetchContext, nominationId, contact, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/contacts`, {
    method: 'POST',
    body: JSON.stringify(contact),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<ContactRef>(fetchContext.errorStore, response, 'create nomination contact'));
